import { setGetListLanguageAction } from '../action';
import { getListLanguage } from '../api/getListLanguage';

export const setGetListLanguage = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListLanguage(params);

            dispatch(setGetListLanguageAction(data.data));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}